/*
 * Async function to fetch a blob and convert it to a base64 string
 * 
 * Ref: https://stackoverflow.com/questions/18650168/convert-blob-to-base64
 */
export const blobToBase64 = blob => new Promise(resolve => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.readAsDataURL(blob)
  })


// WEBPACK FOOTER //
// client/utils/blob.js